import React from 'react';
import { CircleCheck, X } from 'lucide-react';
import './ConfirmDialog.css';

export default function ConfirmDialog({ title, message, confirmLabel = 'Confirm', confirmingLabel = 'Adding…', confirming, onConfirm, onCancel }) {
  return (
    <div className="cd-overlay" onClick={onCancel}>
      <div className="cd-modal" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="cd-close" onClick={onCancel} aria-label="Close" disabled={confirming}>
          <X size={18} />
        </button>
        <div className="cd-icon"><CircleCheck size={22} /></div>
        <h3>{title}</h3>
        {message && <p className="cd-message">{message}</p>}
        <div className="cd-actions">
          <button type="button" className="ap-btn ap-btn-primary" onClick={onConfirm} disabled={confirming}>
            {confirming ? confirmingLabel : confirmLabel}
          </button>
          <button type="button" className="ap-btn ap-btn-ghost" onClick={onCancel} disabled={confirming}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
